module.exports = __webpack_public_path__ + "static/media/parking.f84f9649.svg";